import { isDev } from '@/config/env'

import * as RUMService from './RUM'

export const reportError = (error: unknown, extra?: Record<string, unknown>) => {
  if (isDev()) {
    console.error(error, extra)
    return
  }
  RUMService.reportError(error, extra)
}

export const reportErrorMessage = (message: string, extra?: Record<string, unknown>) => {
  if (isDev()) {
    console.error(message, extra)
    return
  }

  RUMService.reportError(message, extra)
}

export const reportWarning = (message: string) => {
  console.error(message)
}
